import { mutatorAction } from "satcheljs";
import { getStore } from "../store/zoomStore";
import { ZOOM_INCREMENTS, DEFAULT_ZOOM } from "../utils/constants";
import { saveZoomIncrementToStorage } from "../utils/localStorage";

/*
 * Resets current zoom to default zoom (100%)
 */
/* eslint-disable-next-line owa-custom-rules/require-add-identifier-to-mutator-action-variables -- (https://aka.ms/OWALintWiki)
 * Mutator action variables should end with 'Mutator' so that we can more easily identify potential misuses of it.
 *	> Please add 'Mutator' substring add the end of the mutator action variable name. */
export const zoomScaleReset: () => void = mutatorAction("zoomScaleReset", (): void => {
    const store = getStore();
    store.zoomIncrementIndex = ZOOM_INCREMENTS.indexOf(DEFAULT_ZOOM);
    // Save in local storage the current zoom setting
    saveZoomIncrementToStorage(ZOOM_INCREMENTS[store.zoomIncrementIndex]);
});

/*
 * Increases current zoom scale. It uses the zoom increments array index
 * to set the new zoom scale.
 */
/* eslint-disable-next-line owa-custom-rules/require-add-identifier-to-mutator-action-variables -- (https://aka.ms/OWALintWiki)
 * Mutator action variables should end with 'Mutator' so that we can more easily identify potential misuses of it.
 *	> Please add 'Mutator' substring add the end of the mutator action variable name. */
export const zoomInScaleUpdate: () => void = mutatorAction("zoomInScaleUpdate", (): void => {
    const store = getStore();
    if (store.zoomIncrementIndex < ZOOM_INCREMENTS.length - 1) {
        store.zoomIncrementIndex += 1;
    }
    // Save in local storage the current zoom setting
    saveZoomIncrementToStorage(ZOOM_INCREMENTS[store.zoomIncrementIndex]);
});

/*
 * Decreases current zoom scale. It uses the zoom increments array index
 * to set the new zoom scale.
 */
/* eslint-disable-next-line owa-custom-rules/require-add-identifier-to-mutator-action-variables -- (https://aka.ms/OWALintWiki)
 * Mutator action variables should end with 'Mutator' so that we can more easily identify potential misuses of it.
 *	> Please add 'Mutator' substring add the end of the mutator action variable name. */
export const zoomOutScaleUpdate: () => void = mutatorAction("zoomOutScaleUpdate", (): void => {
    const store = getStore();
    if (store.zoomIncrementIndex > 0) {
        store.zoomIncrementIndex -= 1;
    }
    // Save in local storage the current zoom setting
    saveZoomIncrementToStorage(ZOOM_INCREMENTS[store.zoomIncrementIndex]);
});

/*
 * Sets current zoom scale according to the zoom increments array index.
 * @param zoomIndex: zoom increments array index of the desired zoom
 *                   scale
 */
/* eslint-disable-next-line owa-custom-rules/require-add-identifier-to-mutator-action-variables -- (https://aka.ms/OWALintWiki)
 * Mutator action variables should end with 'Mutator' so that we can more easily identify potential misuses of it.
 *	> Please add 'Mutator' substring add the end of the mutator action variable name. */
export const zoomScaleUpdate: (zoomIndex: number) => void = mutatorAction("zoomScaleUpdate", (zoomIndex: number) => {
    const store = getStore();
    store.zoomIncrementIndex = zoomIndex;
    // Save in local storage the current zoom setting
    saveZoomIncrementToStorage(ZOOM_INCREMENTS[store.zoomIncrementIndex]);
});

/*
 * Show embiggen controls
 */
/* eslint-disable-next-line owa-custom-rules/require-add-identifier-to-mutator-action-variables -- (https://aka.ms/OWALintWiki)
 * Mutator action variables should end with 'Mutator' so that we can more easily identify potential misuses of it.
 *	> Please add 'Mutator' substring add the end of the mutator action variable name. */
export const showZoomCallout: (context: string) => void = mutatorAction("showZoomControl", (context: string): void => {
    const store = getStore();
    const viewState = store.zoomViewStates.get(context);
    if (viewState) {
        viewState.isCalloutVisible = true;
    }
});

/*
 * Hide embiggen controls
 */
/* eslint-disable-next-line owa-custom-rules/require-add-identifier-to-mutator-action-variables -- (https://aka.ms/OWALintWiki)
 * Mutator action variables should end with 'Mutator' so that we can more easily identify potential misuses of it.
 *	> Please add 'Mutator' substring add the end of the mutator action variable name. */
export const hideZoomCallout: (context: string) => void = mutatorAction("hideZoomControl", (context: string): void => {
    const store = getStore();
    const viewState = store.zoomViewStates.get(context);
    if (viewState) {
        viewState.isCalloutVisible = false;
    }
});
